import { AppMode, AppStatus } from "@bprotsyk/aso-core";

export enum AppPlatform {
  ANDROID = 'android',
  IOS = 'ios',
}

export const emptyAppState = {
  id: 0,
  name: "",
  bundle: "",
  enabled: true,
  geos: [] as string[],
  appMode: AppMode.OFFERWALL,
  status: AppStatus.READY,
  appPlatform: undefined as unknown as AppPlatform,
  campaign: null,
  appsflyerParams: {
    apiToken: "",
    appId: "",
    devKey: "",
  },
  adjustParams: null,
  domainParams: {
    name: ""
  },
  offerwallParams: {
    version: 'MFO',
    path: "",
    sectionsListId: 1,
    defaultLogicEnabled: true,
  },
  policyPath: "none",
  file: null,
};
